import { Link } from "react-router-dom";
import { getUserRole } from "./auth-utils";

export default function ErrorFallback({ unrecoverable = false }) {
    return (
        <div className="mt-4 pb-2 flex flex-col items-center">
            <i className="bi bi-exclamation-circle fs-1" style={{ color: "var(--ngf-red)" }} />
            <h2 className="text-3xl">An unexpected error occurred.</h2>
            {unrecoverable ? (
                <a className="red-link fs-5" href="/">Back to homepage</a>
            ) : (
                <Link className="red-link fs-5" to="/">Back to homepage</Link>
            )}
            {getUserRole() !== "ADMIN" && <i className="text-muted my-4">
                If the error persists, please contact us at <a href="mailto:info@nextgenerationfocus.org" className="red-link">info@nextgenerationfocus.org</a>
            </i>}
        </div>
    );
}